import * as STORAGE from 'constants/storage-items'

const save = (id, value) => sessionStorage.setItem(id, value)
const get = (id) => sessionStorage.getItem(id)

export const saveAuthToken = (token) => save(STORAGE.TOKEN, token)
export const getAuthToken = () => get(STORAGE.TOKEN)
